class StackingCards extends HTMLElement {
  constructor() {
    super();
    this.blockWrappers = this.querySelectorAll(".technology_block_wrapper");
    this.blockContainers = this.querySelectorAll(".technology_block_container");
    this.observer = null;
  }

  connectedCallback() {
    this.calculatePositions();

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.addListeners();
        } else {
          this.removeListeners();
        }
      });
    });

    this.observer.observe(this);
  }

  addListeners() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.calculatePositions)
  }

  removeListeners() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.calculatePositions)
  }

  handleScroll = () => {
    if (!this.blockContainers) return

    this.blockContainers.forEach((block, index) => {
      if (index == 0) return

      let prevBlock = this.blockContainers[index - 1];
      let prevBlockBottom = prevBlock.getBoundingClientRect().bottom;
      let currentBlock = this.blockContainers[index];
      let currentBlockTop = currentBlock.getBoundingClientRect().top;
      
      if (prevBlockBottom >= currentBlockTop) {
        let scaleValue = (prevBlockBottom - currentBlockTop) / 2;
        prevBlock.style.transform = `scale3d(${1 - (scaleValue * 0.0005).toFixed(3)}, ${1 - (scaleValue * 0.0005).toFixed(3)}, 1)`;
      } else {
        prevBlock.style.transform = "scale3d(1,1,1)";
      }
    })
  }

  calculatePositions = () => {
    if (!this.blockWrappers) return

    const firstTop = 80;
    let blockContainerHeight = this.querySelector('.technology_block_container').offsetHeight;
    if (!blockContainerHeight) return

    this.blockWrappers.forEach((block, index) => {
      if (index == 0) return
      
      block.style.top = `${firstTop * (index) + blockContainerHeight * index}px`;
      block.style.zIndex = `${(index + 1)}`;
    })

    this.querySelector(".technology_blocks_container").style.height = `calc(${this.blockWrappers[this.blockWrappers.length -1].style.top} + ${blockContainerHeight}px)`
  }
}

customElements.define("stacking-cards", StackingCards);
